import { useOnMount } from "../../common/hooks/useOnMount";
import { trackAffiliateOnLoad } from "../Analytics/ga/affiliate";

export const useAffiliateTracking = () => {
  useOnMount(trackAffiliateOnLoad);
};
